import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
//git teste
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
